#import "./AutomationGraphFields.graphql"
#import "./AutomationGraphRulesFields.graphql"
#import "./AutomationLiveFields.graphql"

fragment AutomationEditorFields on Automation {
  id
  ...AutomationLiveFields
  name
  kind
  templateKey
  createdAt
  audience {
    match
    conditions {
      field
      op
      boolValue
      numberValue
      stringValues
      nodeId
    }
  }
  contactListIds
  graph {
    ...AutomationGraphFields
  }
  # Строка списка читает событие триггера отсюда: ответ сохранения и
  # запуска обновляет её в кеше без перечитывания списка.
  triggerEvent
  graphRules {
    ...AutomationGraphRulesFields
  }
  graphIssues {
    nodeId
    code
    exitRuleId
  }
  exitRules {
    id
    name
    kind
    event
    scope
    filter {
      match
      conditions {
        field
        op
        boolValue
        numberValue
        stringValues
        nodeId
      }
    }
  }
  reentry {
    mode
    cooldownDays
  }
}
